import {SubscriptionSvc} from '../services/SubscriptionSvc';

class SubscriptionPriceBlock implements ng.IComponentController {
    discountedMonthly: number;
    discountedAnnual: number;
    monthly: number;
    annual: number;
    discount: number;

    constructor(private subscriptionSvc: SubscriptionSvc) {
    }

    $onChanges() {
        if (!this.discount) return;
        this.discountedAnnual  = this.getDiscountPrice(this.annual);
        this.discountedMonthly = this.getDiscountPrice(this.monthly);
    }

    private getDiscountPrice(price: number) {
        return this.subscriptionSvc.round(price * this.subscriptionSvc.calcDiscount(this.discount))
    }
}

angular.module('animatronApp.settings').component('subscriptionPriceBlock', {
    bindings: {
        monthly: '<',
        annual: '<',
        discount: '<'
    },
    controller: SubscriptionPriceBlock,
    templateUrl: require('settings/subscription-price-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/subscriptionPriceBlock.ts